import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { HOUR_SETS, PERIODS } from "../busy-times-utils";
import DoorsFilter from "./DoorsFilter";
import { CustomRange } from "./LogsFilters";
import QuickToggle from "./QuickToggle";

const BusyFilters = ({
  filters,
  timeZone,
  locations,
  canExport,
  exporting,
  onChange,
  onExport,
}) => {
  const { t } = useTranslation("coaching-portal");
  const [customOpen, setCustomOpen] = useState(filters.period === "custom");

  useEffect(() => {
    setCustomOpen(filters.period === "custom");
  }, [filters.period]);

  const locationOptions = locations.map((name) => ({ id: name, label: name }));
  const selectedLocations = filters.locations.map((name) => ({
    id: name,
    label: name,
  }));

  return (
    <div className="door-filters door-filters--busy">
      <div className="door-filters__bar">
        {locations.length > 0 && (
          <DoorsFilter
            doors={locationOptions}
            selected={selectedLocations}
            allKey="doorAccess.busy.allLocations"
            countKey="doorAccess.busy.locationsCount"
            onChange={(selected) =>
              onChange({
                ...filters,
                locations: selected.map((location) => location.id),
              })
            }
          />
        )}

        <QuickToggle
          label={t("doorAccess.busy.hoursLabel")}
          value={filters.hours}
          options={Object.keys(HOUR_SETS).map((value) => ({
            value,
            label: t(`doorAccess.busy.hours.${value}`),
          }))}
          onSelect={(hours) => onChange({ ...filters, hours })}
        />

        <span className="door-grow" />

        <QuickToggle
          label={t("doorAccess.busy.periodLabel")}
          value={customOpen ? "custom" : filters.period}
          options={PERIODS.map((value) => ({
            value,
            label: t(`doorAccess.busy.period.${value}`),
          }))}
          onSelect={(period) => {
            if (period === "custom") setCustomOpen(true);
            else {
              setCustomOpen(false);
              onChange({ ...filters, period, customFrom: "", customTo: "" });
            }
          }}
        />

        {canExport && (
          <button
            type="button"
            data-button-type="primary"
            sz="small" //NOSONAR
            disabled={exporting}
            onClick={onExport}
          >
            {exporting
              ? t("doorAccess.filters.exporting")
              : t("doorAccess.filters.export")}
          </button>
        )}
      </div>

      {customOpen && (
        <CustomRange
          filters={{
            customFrom: filters.customFrom,
            customTo: filters.customTo,
          }}
          timeZone={timeZone}
          onApply={(customFrom, customTo) =>
            onChange({ ...filters, period: "custom", customFrom, customTo })
          }
        />
      )}
    </div>
  );
};

export default BusyFilters;
